import { useEffect, useRef } from "react";
import { AD_CLIENT } from "../../config/adSlots";

function AdSense({ adSlot, adFormat = "auto", adLayout, fullWidthResponsive = false, style = {} }) {
    const adRef = useRef(null);

    useEffect(() => {
        if (adRef.current && adRef.current.offsetWidth > 0) {
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            } catch (e) {
                // ad already initialized
            }
        }
    }, []);

    return (
        <ins
            ref={adRef}
            className="adsbygoogle"
            style={{ display: "block", ...style }}
            data-ad-format={adFormat}
            data-ad-layout={adLayout || undefined}
            data-ad-client={AD_CLIENT}
            data-ad-slot={adSlot}
            data-full-width-responsive={fullWidthResponsive ? "true" : undefined}
        />
    );
}

export default AdSense;
